'use client'

import Link from 'next/link'
import { AuthLayout } from '@/components/auth/AuthLayout'
import { ForgotPasswordForm } from '@/components/auth/ForgotPasswordForm'
import { useI18n } from '@/components/I18nProvider'

export default function ForgotPasswordPage() {
  const { t } = useI18n()

  return (
    <AuthLayout
      title={t({ es: 'Recupera tu acceso', en: 'Recover your access' })}
      subtitle={t({ es: 'Solicita un codigo, actualiza tu contrasena y vuelve a entrar.', en: 'Request a code, update your password, and sign back in.' })}
      topActionHref="/login"
      topActionLabel={t({ es: 'Iniciar sesion', en: 'Sign in' })}
      footer={
        <div className="text-sm text-muted">
          <Link href="/login" className="font-medium text-[#0f766e] hover:underline">
            {t({ es: 'Volver a iniciar sesion', en: 'Back to sign in' })}
          </Link>
        </div>
      }
    >
      <ForgotPasswordForm />
      <div className="rounded-3xl border border-black/6 bg-[#f8f5ff] p-5 text-sm text-slate-700">
        <h2 className="mb-2 text-base font-semibold">{t({ es: 'Seguridad primero', en: 'Security first' })}</h2>
        <p className="text-slate-600">
          {t({
            es: 'Nunca compartas tu codigo. Si no solicitaste esto, ignora el mensaje.',
            en: "Never share your code. If you didn't request this, ignore it.",
          })}
        </p>
      </div>
    </AuthLayout>
  )
}
